import { render } from "./admin-header.vue?vue&type=template&id=6c56c331"
import script from "./admin-header.vue?vue&type=script&lang=js"
export * from "./admin-header.vue?vue&type=script&lang=js"

import "./admin-header.vue?vue&type=style&index=0&id=6c56c331&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__